import { useEffect, useState } from "react";

interface DotDotDotProps {
    enabled: boolean;
}

export function DotDotDot({ enabled = true }: DotDotDotProps) {
    const [dots, setDots] = useState<string>("...");

    useEffect(() => {
        if (!enabled)
            return;

        const state = {
            dots: "...",
        };
        setDots(state.dots);

        const intervalID = setInterval(() => {
            if (state.dots === "...") {
                state.dots = ".";
            } else if (state.dots === ".") {
                state.dots = "..";
            } else {
                state.dots = "...";
            }
            setDots(state.dots);
        }, 1000);

        return () => {
            clearInterval(intervalID);
        };
    }, [enabled]);

    if (!enabled)
        return (<></>);

    return (
        <span className="relative inline-block">
            <span className="inline-block text-transparent">
                ...
            </span>
            <span className="absolute left-0 top-0 block">
                {dots}
            </span>
        </span>
    );
}
